import React from 'react'
import classNames from 'classnames'
import { string, node, oneOfType, object, array } from 'prop-types'

const Body = ({ children, className, emptyMessage }) => (
  <tbody className={classNames('sw-table-body', className)}>{children || emptyMessage}</tbody>
)

Body.displayName = 'Body'

Body.propTypes = {
  /** Component children */
  children: node,
  /** Custom className */
  className: oneOfType([string, object, array]),
  /** Message to display if element has no children */
  emptyMessage: node
}

Body.defaultProps = {
  emptyMessage: 'Nothing to display.'
}

export default Body
